// extracted by mini-css-extract-plugin
export var container = "_21-0";
export var disabled = "_21-4";
export var fullWidth = "_21-3";
export var lined = "_21-1";
export var selected = "_21-5";
export var tab = "_21-2";